// @vendors
const { Promise } = require('es6-promise');

// @actions
const actionTypes = require('constants/actionTypes');

// @utils
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

// @constants
const {
    TYPE_STOCKS,
    TYPE_PLANS,
    TYPE_WARRANTS,
    TYPE_FUNDS,
    TYPE_ETFS,
    BROKER_INVESTMENT_FUNDS_PRODUCT_URL_PARAMETER,
    BROKER_PLANS_PRODUCT_URL_PARAMETER,
    BROKER_ADVANCED_SEARCH_URL_FILTER_DATA_POINTS,
    //BROKER_ADVANCED_SEARCH_ETFS_SPCSYMBOL_MARKETS,
    BROKER_ADVANCED_SEARCH_ETFS_REQUEST_IDENTIFIER
} = require('constants/index');

const etfsFundsQuery  = {
    query: {
        pageSize: "5000",
        outputType: "json",
        languageId: "es-ES",
        universeIds: "FOEUR$$ALL_2118",
        filterDataPoints: BROKER_ADVANCED_SEARCH_URL_FILTER_DATA_POINTS
    }
};

const getFiltersFailure = (response, product) => {
    return {
        type: actionTypes.BROKER_ADVANCED_SEARCH_GET_FIELDS_FAILURE,
        payload: {
            data: response,
            product
        }
    };
}

const getFiltersSuccess = (response, product) => {
    return {
        type: actionTypes.BROKER_ADVANCED_SEARCH_GET_FIELDS_SUCCESS,
        payload: {
            data: response,
            product
        }
    };
}

const filtersAreFetching = () => {
    return {
        type: actionTypes.BROKER_ADVANCED_SEARCH_FIELDS_ARE_FETCHING,
        payload: {
            isFetching: true
        }
    };
};

const fetchingDone = () => {
    return {
        type: actionTypes.BROKER_ADVANCED_SEARCH_FETCTHING_DONE,
        payload: {
            fetchingDone: true
        }
    };
};

const getFundsFiltersRequest = (dispatch) => {

    const prodUrl = BROKER_INVESTMENT_FUNDS_PRODUCT_URL_PARAMETER;

    dispatch(filtersAreFetching());

    return APIGet(dispatch, apiURLBuilder.getURL('brokerAdvancedSearchFundsPlansFilters', {type: prodUrl}), etfsFundsQuery)
        .then(response => {
            dispatch(getFiltersSuccess(response, TYPE_FUNDS));
        }, response => {
            dispatch(getFiltersFailure(response, TYPE_FUNDS));
        }
    );
};

const getPlansFiltersRequest = (dispatch) => {

    const prodUrl = BROKER_PLANS_PRODUCT_URL_PARAMETER;

    const plansQuery  = {
        query: {
            pageSize: "5000",
            outputType: "json",
            languageId: "es-ES",
            universeIds: "FOESP$$PEN_2119",
            filterDataPoints: BROKER_ADVANCED_SEARCH_URL_FILTER_DATA_POINTS
        }
    };

    dispatch(filtersAreFetching());

    return APIGet(dispatch, apiURLBuilder.getURL('brokerAdvancedSearchFundsPlansFilters', {type: prodUrl}), plansQuery)
        .then(response => {
            dispatch(getFiltersSuccess(response, TYPE_PLANS));
        }, response => {
            dispatch(getFiltersFailure(response, TYPE_PLANS));
        }
    );
};

const getWarrantsFiltersRequest = (dispatch) => {

    const fields = ['underlyings', 'products', 'types', 'issuers'];

    const makePromise = (field) => {
        return new Promise((resolve) => {

            const requestData = {
                query: {
                    pageNum: "0",
                    pageSize: "0"
                }
            };

            APIGet(dispatch, apiURLBuilder.getURL('brokerAdvancedSearchWarrantsFilters', {filterType: field}), requestData)
                .then(response => {
                    return resolve({response, field});
                })
                .catch(response => dispatch(getFiltersFailure(response.error, TYPE_WARRANTS)));
        })
    };

    const promises = fields.reduce((prev, curr) => {
        return [...prev, makePromise(curr)];
    }, []);

    dispatch(filtersAreFetching());

    return Promise.all(promises).then(values => {
            dispatch(getFiltersSuccess(values, TYPE_WARRANTS));
        }).catch(response => dispatch(getFiltersFailure(response.error, TYPE_WARRANTS)));
};

const getStocksFiltersRequest = (dispatch) => { // this is ready to take more endpoints such as currencies
    const fieldsEndpoints = [
        {field: 'markets', url: 'brokerAdvancedSearchStocksIndexes'}
    ];

    const requestData = {
        query: {
            pageNum: "0",
            pageSize: "0"
        }
    };

    dispatch(filtersAreFetching());

    const makePromise = (endPoint) => {
        return APIGet(dispatch, apiURLBuilder.getURL(endPoint.url), requestData)
            .then(response => {
                return { response, field: endPoint.field };
            })
            .catch(response => dispatch(getFiltersFailure(response.error, TYPE_STOCKS)));

    };

    const promises = fieldsEndpoints.reduce((prev, curr) => {
        return [...prev, makePromise(curr)];
    }, []);

    return Promise.all(promises).then(values => {
            dispatch(getFiltersSuccess(values, TYPE_STOCKS));
            dispatch(fetchingDone());
        }).catch(response => {
            dispatch(getFiltersFailure(response.error, TYPE_STOCKS));
            dispatch(fetchingDone());
        });

};

const getETFsFiltersRequest = (dispatch) => {
    const requestData = {
        query: {
            category: BROKER_ADVANCED_SEARCH_ETFS_REQUEST_IDENTIFIER,
            pageNum: "0",
            pageSize: "0"
        }
    };

    dispatch(filtersAreFetching());

    return APIGet(dispatch, apiURLBuilder.getURL('brokerAdvancedSearchETFsFilters'), requestData)
        .then(values => dispatch(getFiltersSuccess(values, TYPE_ETFS)))
        .catch(response => dispatch(getFiltersFailure(response.error, TYPE_ETFS)));
};

const getFilters = () => (dispatch) => {
    getFundsFiltersRequest(dispatch);
    getPlansFiltersRequest(dispatch);
    getETFsFiltersRequest(dispatch);
    getWarrantsFiltersRequest(dispatch);
    getStocksFiltersRequest(dispatch)
};

module.exports = getFilters;
